import { ASSET_TYPE_ID } from "../../../const";
import blobUrlFormatHelper from "../../blobUrlFormatHelper";
import { useAssetManagerState } from "../AssetManagerContext/AssetManagerProvider";

interface AssetThumbnailProps {
  url?: string;
}

export default function AssetThumbnail({ url }: Readonly<AssetThumbnailProps>) {
  const { assetLibraryDisplayedAssetType, currentSelectedAsset } = useAssetManagerState();

  if (url) {
    return <img src={url} style={{ maxWidth: "100%", maxHeight: 300, display: "block" }} />;
  }

  let path = "";
  const alt = currentSelectedAsset.name;

  if (assetLibraryDisplayedAssetType === ASSET_TYPE_ID.IMAGE) {
    path = blobUrlFormatHelper(currentSelectedAsset.blobPath);
  }

  if (assetLibraryDisplayedAssetType === ASSET_TYPE_ID.PANORAMIC_IMAGE && currentSelectedAsset.panoramicImages) {
    path = blobUrlFormatHelper(`${currentSelectedAsset.blobPath}/${currentSelectedAsset.panoramicImages.frontImage}`);
  }

  if (assetLibraryDisplayedAssetType === ASSET_TYPE_ID.SMART_OBJECT && currentSelectedAsset.smartObject) {
    const correctPathName = currentSelectedAsset.smartObject.smartObjectSvg.toLowerCase().replaceAll(" ", "_");
    path = blobUrlFormatHelper(`${currentSelectedAsset.blobPath}/${correctPathName}`);
  }

  return path ? <img src={path} alt={alt} style={{ maxWidth: "100%", maxHeight: 300, display: "block" }} /> : null;
}
